export { Collapse } from 'antd';
export { default } from './Collapse';